var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Buffer } from "buffer";
/** @internal */
var GooglePaySdkService = /** @class */ (function () {
    function GooglePaySdkService(pspName) {
        var _this = this;
        this.handleResponse = function (response) { return __awaiter(_this, void 0, void 0, function () {
            var xRequestId, responseJson, responseModel, errorModel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        xRequestId = response.headers.get("X-REQUESTID");
                        if (!response.ok) return [3 /*break*/, 2];
                        return [4 /*yield*/, response.json()];
                    case 1:
                        responseJson = _a.sent();
                        responseModel = {
                            xRequestId: xRequestId ? xRequestId : undefined,
                            responseJson: responseJson,
                        };
                        return [2 /*return*/, Promise.resolve(responseModel)];
                    case 2:
                        errorModel = {
                            xRequestId: xRequestId ? xRequestId : undefined,
                            error: "".concat(response.status, " ").concat(response.statusText),
                        };
                        return [2 /*return*/, Promise.reject(errorModel)];
                }
            });
        }); };
        this.getContactLine2 = function (address) {
            var line2 = address === null || address === void 0 ? void 0 : address.address2;
            if (address === null || address === void 0 ? void 0 : address.address3) {
                line2 = line2 ? "".concat(line2, ", ").concat(address.address3) : address.address3;
            }
            return line2;
        };
        this.getContactZip = function (address) {
            var zip = address === null || address === void 0 ? void 0 : address.postalCode;
            if (address === null || address === void 0 ? void 0 : address.sortingCode) {
                zip = zip ? "".concat(zip, ", sortingCode: ").concat(address.sortingCode) : "sortingCode: ".concat(address.sortingCode);
            }
            return zip;
        };
        this.completePayment = function (paymentToken, transactionId, shippingAddress, billingAddress, email) { return __awaiter(_this, void 0, void 0, function () {
            var completePaymentRequest, paymentRequestBillingContact, paymentRequestShippingContact;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        completePaymentRequest = {
                            token: Buffer.from(paymentToken).toString("base64"),
                            transactionId: transactionId,
                        };
                        if (billingAddress) {
                            paymentRequestBillingContact = {
                                city: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.locality,
                                countryCode: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.countryCode,
                                line1: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.address1,
                                line2: this.getContactLine2(billingAddress),
                                name: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.name,
                                phoneNumber: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.phoneNumber,
                                state: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.administrativeArea,
                                zip: this.getContactZip(billingAddress),
                            };
                            completePaymentRequest.billingContact = paymentRequestBillingContact;
                        }
                        if (shippingAddress) {
                            paymentRequestShippingContact = {
                                city: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.locality,
                                countryCode: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.countryCode,
                                line1: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.address1,
                                line2: this.getContactLine2(shippingAddress),
                                name: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.name,
                                phoneNumber: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.phoneNumber,
                                state: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.administrativeArea,
                                zip: this.getContactZip(shippingAddress),
                            };
                            completePaymentRequest.shippingContact = paymentRequestShippingContact;
                        }
                        if (email) {
                            completePaymentRequest.emailAddress = email;
                        }
                        return [4 /*yield*/, fetch("".concat(this.baseUrl, "/completePayment"), {
                                method: "POST",
                                body: JSON.stringify(completePaymentRequest),
                                headers: {
                                    "Content-Type": "application/json",
                                },
                            })
                                .then(function (response) { return _this.handleResponse(response); })
                                .catch(function (error) { return error; })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.baseUrl = "https://".concat(pspName, ".googlepayecom.payair.com");
    }
    return GooglePaySdkService;
}());
export default GooglePaySdkService;
